const KEY = "hubpilot-pybricks-ready";

// Remembered per browser once someone says their hub has Pybricks firmware (or finishes the install guide).
export const hubReady = () => localStorage.getItem(KEY) === "1";
export const rememberHubReady = () => localStorage.setItem(KEY, "1");

export const isWindows = () => {
  const platform = navigator.userAgentData?.platform || navigator.platform;
  return platform ? /^win/i.test(platform) : /Windows/.test(navigator.userAgent);
};
